import * as React from 'react';
import './ErrorBoundary.pcss';

interface IErrorBounmdary_Props {
  errorMessage?:string;
}

export class ErrorBoundary extends React.Component<IErrorBounmdary_Props> {
  constructor(props:IErrorBounmdary_Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, info);
    console.log(error);
    console.log(info);
  }

  render() {
    // @ts-ignore
    if (this.state.hasError) {
      return <div className={"errorBoundary"}>{this.props.errorMessage ? this.props.errorMessage : "Something went wrong."}</div>;
    }
    return this.props.children;
  }
}
